module.exports = __webpack_public_path__ + "img/header-search.c4c0545c.svg";